
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.688 8.282a5.914 5.914 0 015.908-5.908 5.914 5.914 0 015.908 5.908 5.914 5.914 0 01-5.908 5.908 5.914 5.914 0 01-5.908-5.908zm17.285 10.514l-5.597-5.598a7.55 7.55 0 001.816-4.916c0-4.188-3.408-7.596-7.596-7.596C3.407.686 0 4.094 0 8.282c0 4.189 3.407 7.596 7.596 7.596a7.559 7.559 0 004.547-1.524l5.637 5.635 1.193-1.193z"}})])
          )
        }
      }
    